import axios from 'axios';
import { createSignedPatchRequest } from 'utils/createSignedRequestsHelpers';

export const setAdminSensorOrderReady = async (orderId) => {
  const request = await createSignedPatchRequest({
    apiPath: `admin/renolog/sensor-orders/${orderId}/set-ready`,
    body: {},
    //isLocalApiRequest: true,
  });
  const response = await axios(request);
  return response.data;
};
